import i18n from '@/utils/i18n';
import React from 'react';
import { Button, EmptyState, Icons } from '@usepepper/sprout-kit-ui';

interface Props {
  description?: string;
  icon?: React.ReactNode;
  onRetry: () => void;
  retryLabel?: string;
  title: string;
}

export const ErrorState: React.FC<Props> = ({
  description = i18n.t('finance_hub.error.description'),
  icon,
  onRetry,
  retryLabel = i18n.t('refresh'),
  title,
}) => (
  <EmptyState
    action={
      <Button
        accessibilityLabel={retryLabel}
        onPress={onRetry}
        size="$sm"
        variant="secondary"
      >
        {retryLabel}
      </Button>
    }
    description={description}
    icon={icon ?? <Icons.AlertCircle color="$iconNegativePrimary" />}
    title={title}
    tone="error"
  />
);
